"use strict";
var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var drawSilkscreenOfFootprintDescriptionTo2D = require("./../../../shared/index.js").drawSilkscreenOfFootprintDescriptionTo2D;
var drawHoleDataTo2D = require("./../../../shared/index.js").drawHoleDataTo2D;

var PadInteractionView = require("./../../../footprint-editor/extensions/padViewer/padInteractionView.js");
var SolderMaskInteractionView = require("./../../../shared/extensions/solderMask/solderMaskViewer/solderMaskInteractionView.js");
var SolderPasteInteractionView = require("./../../../shared/extensions/solderPaste/solderPasteViewer/solderPasteInteractionView.js");
var GlueInteractionView = require("./../../../shared/extensions/glue/glueViewer/glueInteractionView.js");
var RestrictInteractionView = require("./../../../shared/extensions/restrict/restrictViewer/restrictInteractionView.js");
var HoleInteractionView = require("./../../../shared/extensions/holeViewer/holeInteractionView.js");
var SilkscreenInteractionView = require("./../../../shared/extensions/silkscreen/silkscreenViewer/silkscreenInteractionView.js");
var DocumentationInteractionView = require("./../../../shared/extensions/documentation/documentationViewer/documentationInteractionView.js");


var FootprintInteractionView = function (editorView, interactionModel, parentGroup, layers) {
    var self  = this;

    this.editorView = editorView;
    this.gui = this.editorView;
    this.interactionModel = interactionModel;
    this.parentGroup = parentGroup;
    this.layers = layers;

    this.data = this.interactionModel.data;

    this.cameraModel = this.editorView.editorModel.cameraModel();

    this.initGroups(parentGroup, [
                                  layers.silkscreenTop,
                                  layers.silkscreenBottom,
                                  layers.documentationTop,
                                  layers.documentationBottom,
                                  layers.drill,
                                  layers.soldermaskTop,
                                  layers.soldermaskBottom,
                                  layers.solderpasteTop,
                                  layers.solderpasteBottom,
                                  layers.glueTop,
                                  layers.glueBottom,
                                  layers.restrictTop,
                                  layers.restrictBottom
                                 ]);


    
    this.interactionViews = new lib_core.Collections.HashSet();

    this.data.description.onChange(this, function() {
        if(self.data.isAlive() && self.data.description() && self.data.description().isAlive())
            self.editorView.heavyHandler.scheduleHeavy('rebuild_view', self.draw, self, [], self);
    });

    this.draw();


    this.interactionModel.selected.onChange(self, function(value){
        self.setSelected(value);
    },10);

};
lib_core.mixin(FootprintInteractionView, editor_2d.DrawingElement);

module.exports = FootprintInteractionView;

FootprintInteractionView.prototype.draw = function() {
    var self = this;

    //$(this.elementSilkscreenGroup).empty();
    //$(this.elementHoleGroup).empty();
    self.interactionViews.forEach(function (view) {
        view.removeSvg();
    });
    self.interactionViews.removeAll();

    if(!this.interactionModel.isAlive()) return;
    if(!self.data.isAlive()
        || !self.data.description() || !self.data.description().isAlive())
        return;

    buildIVsForCollections(this.data.description().silkscreen, SilkscreenInteractionView);
    buildIVsForCollections(this.data.description().documentation, DocumentationInteractionView);
    buildIVsForCollections(this.data.description().holes, HoleInteractionView);
    buildIVsForCollections(this.data.description().pads, PadInteractionView);
    buildIVsForCollections(this.data.description().solderMask, SolderMaskInteractionView);
    buildIVsForCollections(this.data.description().solderPaste, SolderPasteInteractionView);
    buildIVsForCollections(this.data.description().glue, GlueInteractionView);
    buildIVsForCollections(this.data.description().copperRestricts, RestrictInteractionView);
    buildIVsForCollections(this.data.description().componentRestricts, RestrictInteractionView);
    buildIVsForCollections(this.data.description().viaRestricts, RestrictInteractionView);

    function buildIVsForCollections (collection, viewConstructor) {
        collection.forEach(function(k, element) {
            var IM = self.interactionModel.interactionModelMap.get(element);
            var interactionView = new viewConstructor(self.editorView, IM, self.parentGroup, self.layers);
            self.interactionViews.add(interactionView);
            IM.onDie(self, function(o){ 
                interactionView.removeSvg(); 
            }, 101);
        })
    }
};


FootprintInteractionView.prototype.onMouseDown = function (event, subelement) {
    var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
            .fromJSEvent(event)
            .data( 'mouseCoord', this.editorView.relativeMouseCoord(event) );
    if (subelement) cEvent.element(subelement);
    else cEvent.element(this);

    return this.editorView.stateMachine.handle(cEvent);
};










